export const clinicalStyles = {
  image: {
    titleTransparent: process.env.REACT_APP_HEADER_IMAGE,
    title: process.env.REACT_APP_HEADER_IMAGE,
    donateCTA: 'clinical-donate-cta.png',
  },
  color: {
    text: '#1c4c6c',
    textLight: '#1c4c6c',
    knockoutBackground: '#1c4c6c',
    shadow: '#b4b5b6',
    border: '#1c4c6c',
    borderDark: '#1c4c6c',
    selectedBackground: '#fff', //'#d1ecfa',
    pro: '#1D9645',
    con: '#961E1D',
  },
  font: {
    heading: 'League Spartan',
    subheading: 'Sanchez',
    paragraph: 'Glacial Indifference',
  },
  strings: {
    title: process.env.REACT_APP_TITLE,
    tagline: process.env.REACT_APP_TAGLINE,
  },
  /*  textSize: {
    XXS: '14px',
  },*/
  layout: {
    topImageWidth: 'auto',
  },
}
